import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { FileFormats } from "../../../libs/data/fileFormatTypes";
import FilePreview from "../../../../ui/filePreview/FilePreview";
import { AppIcons } from "../../../../../data/appIcons";
import Buttons from "../../../../ui/button/Buttons";
import "./FileUpload.scss";
import Iconify from "../../../../../layouts/components/iconify/iconify";

const FileUpload = ({
  name = "",
  onClear,
  onChange,
  onBlur,
  onClearAll,
  placeholder,
  fieldSetting,
  onActionClick,
  isDownloadButton,
  selectedFileValues,
  isMultipleFileAllowed = false,
  acceptedFileFormats = FileFormats.ALL,
}) => {
  const [fileValues, setFileValues] = useState(selectedFileValues);

  const fileRef = useRef();

  const handleInputChange = (e) => {
    if (e.target.files?.length > 0) {
      onChange?.(e);
    } else {
      handleClearClick();
    }
  };

  const handleDownloadClick = (index) => {
    onActionClick?.(index);
  };

  const handleClearClick = (index) => {
    if (index !== undefined) {
      const newFileValues = [...fileValues];
      newFileValues.splice(index, 1);
      setFileValues(newFileValues);
      if (onClear) onClear(index);
    }
  };

  const handleClearAll = () => {
    fileRef.current.value = null;
    setFileValues([]);
    onClearAll?.();
  };

  useEffect(() => {
    if (selectedFileValues?.length > 0 && Array.isArray(selectedFileValues)) {
      setFileValues(selectedFileValues.map((file) => file.file));
    } else {
      setFileValues([]);
      handleClearClick();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFileValues]);

  return (
    <>
      <div className="mol-file-uploader">
        {(isMultipleFileAllowed || fileValues?.length === 0) && (
          <>
            <input
              ref={fileRef}
              id={name}
              name={name}
              type="file"
              className="file-input"
              onChange={handleInputChange}
              // onBlur={onBlur}
              accept={acceptedFileFormats}
              multiple={isMultipleFileAllowed}
            />
            <div className="custom-file-selector-design">
              {/* <Image
                imagePath={AppIcons.UploadDocsIcon}
                altText="Please Upload File"
              ></Image> */}
              <div className="attachment-icon">
                <Iconify icon="hugeicons:file-attachment" width="80px" />
              </div>
              <div className="drag-drop-txt">
                <p>Drag & Drop Your File</p>
                <span className="small-txt">
                  {acceptedFileFormats.join(", ")}&nbsp; Formats we support
                </span>
                <br></br>
                <span className="small-txt">
                  Min: <span>{fieldSetting?.minFileSizeInMB} MB</span> & Max:{" "}
                  <span>{fieldSetting?.maxFileSizeInMB} MB</span>
                </span>
              </div>

              <div className="buttons">
                <Buttons
                  textWithIcon={true}
                  imagePath={AppIcons.UploadIcon}
                  buttonTypeClassName="outlined-theme-btn"
                  buttonText="Upload Manually"
                  onClick={handleClearClick}
                />
              </div>
            </div>
          </>
        )}

        {!isMultipleFileAllowed ? (
          <FilePreview
            fileValues={fileValues}
            onClearAll={handleClearAll}
            onClearClick={handleClearClick}
            isDownloadButton={isDownloadButton}
            onDownloadClick={handleDownloadClick}
            isMultipleFileAllowed={isMultipleFileAllowed}
          />
        ) : null}
      </div>
      {isMultipleFileAllowed ? (
        <FilePreview
          fileValues={fileValues}
          onClearAll={handleClearAll}
          onClearClick={handleClearClick}
          isDownloadButton={true}
          onDownloadClick={handleDownloadClick}
          isMultipleFileAllowed={isMultipleFileAllowed}
        />
      ) : null}
    </>
  );
};

FileUpload.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  onClearAll: PropTypes.func,
  placeholder: PropTypes.string,
  fieldSetting: PropTypes.shape({
    minFileSizeInMB: PropTypes.number,
    maxFileSizeInMB: PropTypes.number,
  }),
  onActionClick: PropTypes.func,
  selectedFileValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  isDownloadButton: PropTypes.bool,
  isMultipleFileAllowed: PropTypes.bool,
  acceptedFileFormats: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

export default FileUpload;
